import { gql } from "graphql-tag";

export const getNotificationsCount = gql`
  query GetNotificationsCount($userId: Int!) {
    notifications: notification_deliveries_aggregate(
      where: {
        channel_id: { _eq: 1 }
        read: { _eq: false }
        user_id: { _eq: $userId }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export type GetNotificationCountType = {
  notifications: {
    aggregate: {
      count: number;
    };
  };
};
